export namespace NotificationEnum {
  export const statusName = Object.freeze({
    pending: 'Pending',
    processing: 'Processing',
    published: 'Published',
    cancelled: 'Canceled',
  });

  export const statusLabel = Object.freeze({
    pending: 'PENDING',
    processing: 'PROCESSING',
    published: 'PUBLISH',
    cancelled: 'CANCELLED',
  });

  export const status = Object.freeze({
    pending: 1,
    processing: 2,
    published: 3,
    cancelled: 4,
  });

  export const sentToType = Object.freeze({
    all: {
      name: 'All (Club card & non-club card)',
      value: 1,
    },
    clubCard: {
      name: 'Club card',
      value: 2,
    },
    nonClub: {
      name: 'Non-club card (guest & non-club card)',
      value: 3,
    },
  });

  // TODO: Recheck all direactions
  export const direction = Object.freeze({
    home: {
      name: 'Home',
      value: 'home',
    },
    promotion: {
      name: 'Package',
      value: 'promotion',
    },
  });

  export const tabIndex = Object.freeze({
    list: 0,
  });

  export const type = Object.freeze({
    promotion: 'promotion',
  });
}
